import { UserMenuContent } from "../auth/UserMenuContent";
import { focusRing } from "../ui/control-styles";
import { useTranslation } from "react-i18next";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from "../ui/dropdown-menu";
import type { AuthUser } from "../../auth/auth";
export function HomeAccount({ user, onSignOut }: { user: AuthUser | null; onSignOut: () => void }) {
  const { t } = useTranslation();
  if (!user) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={`inline-flex max-w-full min-w-0 cursor-pointer items-center gap-3.5 rounded-lg tracking-[inherit] text-primary underline decoration-dotted decoration-2 underline-offset-8 hover:text-primary/80 ${focusRing} max-[30rem]:gap-2.5`}
          aria-label={t("auth.accountMenu")}
        >
          <span className="truncate px-0.5">{user.name}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="max-w-[calc(100vw-2rem)] min-w-60" align="center">
        <UserMenuContent user={user} onSignOut={onSignOut} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
